var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ui-content__item-page ui-alert ui-item-page" },
    [
      _c("h2", { staticClass: "ui-item-page__title" }, [_vm._v("UI Alert")]),
      _c("div", { staticClass: "ui-block" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-lg-4 mb-30" },
            [
              _c("h5", { staticClass: "ui-item-page__sub-title" }, [
                _vm._v("Alert basic usage"),
              ]),
              _c("vue-alert", { attrs: { title: "Alert info" } }),
              _c("vue-alert", {
                attrs: { title: "Alert success", type: "success" },
              }),
              _c("vue-alert", {
                attrs: { title: "Alert warning", type: "warning" },
              }),
              _c("vue-alert", {
                attrs: { title: "Error alert", type: "error" },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-lg-4 mb-30" },
            [
              _c("h5", { staticClass: "ui-item-page__sub-title" }, [
                _vm._v("Alert customizable close button"),
              ]),
              _c("vue-alert", {
                attrs: {
                  title: "unclosable alert",
                  type: "success",
                  closable: false,
                },
              }),
              _c("vue-alert", {
                attrs: {
                  title: "customized close-text",
                  type: "info",
                  "close-text": "Gotcha",
                },
              }),
              _c("vue-alert", {
                attrs: { title: "alert with callback", type: "warning" },
                on: { close: _vm.hello },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-lg-4 mb-30" },
            [
              _c("h5", { staticClass: "ui-item-page__sub-title" }, [
                _vm._v("Alert with icon"),
              ]),
              _c("vue-alert", {
                attrs: {
                  title: "success alert",
                  type: "success",
                  "show-icon": "",
                },
              }),
              _c("vue-alert", {
                attrs: { title: "info alert", type: "info", "show-icon": "" },
              }),
              _c("vue-alert", {
                attrs: {
                  title: "warning alert",
                  type: "warning",
                  "show-icon": "",
                },
              }),
              _c("vue-alert", {
                attrs: { title: "error alert", type: "error", "show-icon": "" },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-lg-4 mb-30" },
            [
              _c("h5", { staticClass: "ui-item-page__sub-title" }, [
                _vm._v("Alert center text"),
              ]),
              _c("vue-alert", {
                attrs: {
                  title: "success alert",
                  type: "success",
                  center: "",
                  "show-icon": "",
                },
              }),
              _c("vue-alert", {
                attrs: {
                  title: "info alert",
                  type: "info",
                  center: "",
                  "show-icon": "",
                },
              }),
              _c("vue-alert", {
                attrs: {
                  title: "warning alert",
                  type: "warning",
                  center: "",
                  "show-icon": "",
                },
              }),
              _c("vue-alert", {
                attrs: {
                  title: "error alert",
                  type: "error",
                  center: "",
                  "show-icon": "",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-lg-4 mb-30" },
            [
              _c("h5", { staticClass: "ui-item-page__sub-title" }, [
                _vm._v("Alert with description"),
              ]),
              _c("vue-alert", {
                attrs: {
                  title: "with description",
                  type: "success",
                  description: "This is a description.",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-lg-4 mb-30" },
            [
              _c("h5", { staticClass: "ui-item-page__sub-title" }, [
                _vm._v("Alert with icon and description"),
              ]),
              _c("vue-alert", {
                attrs: {
                  title: "success alert",
                  type: "success",
                  description: "more text description",
                  "show-icon": "",
                },
              }),
              _c("vue-alert", {
                attrs: {
                  title: "info alert",
                  type: "info",
                  description: "more text description",
                  "show-icon": "",
                },
              }),
              _c("vue-alert", {
                attrs: {
                  title: "warning alert",
                  type: "warning",
                  description: "more text description",
                  "show-icon": "",
                },
              }),
              _c("vue-alert", {
                attrs: {
                  title: "error alert",
                  type: "error",
                  description: "more text description",
                  "show-icon": "",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-lg-4 mb-30" },
            [
              _c("h5", { staticClass: "ui-item-page__sub-title" }, [
                _vm._v("Alert with icon and description"),
              ]),
              _c(
                "vue-alert",
                {
                  attrs: {
                    type: "success",
                    "show-icon": "",
                    description: "is",
                  },
                },
                [
                  _vm._t("description", function () {
                    return [
                      _c("span", [
                        _vm._v(
                          "Вы не будете получать уведомление на email пока не подтвердить его"
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "vue-alert__link",
                          attrs: { href: "#" },
                        },
                        [_vm._v("(ссылка)")]
                      ),
                    ]
                  }),
                ],
                2
              ),
              _c(
                "vue-alert",
                {
                  attrs: {
                    title: "info alert",
                    type: "info",
                    description: "more text description",
                    "show-icon": "",
                  },
                },
                [
                  _vm._t("description", function () {
                    return [
                      _c("span", [
                        _vm._v(
                          "Вы не будете получать уведомление на email пока не подтвердить его"
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "vue-alert__link",
                          attrs: { href: "#" },
                        },
                        [_vm._v("(ссылка)")]
                      ),
                    ]
                  }),
                ],
                2
              ),
              _c(
                "vue-alert",
                {
                  attrs: {
                    title: "warning alert",
                    type: "warning",
                    description: "more text description",
                    "show-icon": "",
                  },
                },
                [
                  _vm._t("description", function () {
                    return [
                      _c("span", [
                        _vm._v(
                          "Вы не будете получать уведомление на email пока не подтвердить его"
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "vue-alert__link",
                          attrs: { href: "#" },
                        },
                        [_vm._v("(ссылка)")]
                      ),
                    ]
                  }),
                ],
                2
              ),
              _c(
                "vue-alert",
                {
                  attrs: {
                    title: "error alert",
                    type: "error",
                    description: "more text description",
                    "show-icon": "",
                  },
                },
                [
                  _vm._t("description", function () {
                    return [
                      _c("span", [
                        _vm._v(
                          "Вы не будете получать уведомление на email пока не подтвердить его"
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "vue-alert__link",
                          attrs: { href: "#" },
                        },
                        [_vm._v("(ссылка)")]
                      ),
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }